import { render, staticRenderFns } from "./messagePush.vue?vue&type=template&id=01d63be9&scoped=true"
import script from "./messagePush.vue?vue&type=script&lang=js"
export * from "./messagePush.vue?vue&type=script&lang=js"
import style0 from "./messagePush.vue?vue&type=style&index=0&id=01d63be9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d63be9",
  null
  
)

export default component.exports